export default Object.freeze({
  // MEMBER_FREEZE_
  TITLE: '휴면회원 조회',
  SEARCH_FIELD_DATE: '휴면전환일자',

  LIST_ITEM_MEMBER_MOBILE: '휴대폰번호',
  LIST_ITEM_MEMBER_MAIL: 'e메일 주소',
  LIST_ITEM_MEMBER_REGISTER_DATE: '회원가입일',
  LIST_ITEM_MEMBER_LAST_LOGIN_DATE: '최종로그인',
  LIST_ITEM_MEMBER_PUSH_ON: '푸쉬수신',
  LIST_ITEM_MEMBER_SMS_ON: 'SMS수신',
  LIST_ITEM_MEMBER_DM_ON: 'DM수신',
});
